// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"15d7562f","108":"5cd384dd","300":"a83d794a","444":"7dc51641","592":"249bc6f2","604":"16ad0a7d","656":"afe13b22","752":"ee6afc68"}[chunkId] + ".chunk.js";
};